import { render } from "./LoyaltyCard.vue?vue&type=template&id=d50f23e2&scoped=true"
import script from "./LoyaltyCard.vue?vue&type=script&lang=js"
export * from "./LoyaltyCard.vue?vue&type=script&lang=js"

import "./LoyaltyCard.vue?vue&type=style&index=0&id=d50f23e2&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d50f23e2"]])

export default __exports__